import React from 'react';
import styles from './AccessBackOffice.css';

class AccessBackOffice extends React.Component {
  render() {
    const { onChange, checked, hasSubMenuChecked } = this.props;
    return (
      <div className="row">
        <div className="col-lg-1">
          <div
            style={{ marginTop: '2px' }}
            className={`checkbox checkbox-primary checkbox-circle ${
              !checked && hasSubMenuChecked ? styles['partial-checked'] : ''
            }`}
          >
            <input
              type="checkbox"
              id="access-back-office"
              onChange={onChange}
              checked={checked}
            />
            <label for="access-back-office" />
          </div>
        </div>
        <div className="col-lg-11" style={{ marginLeft: '-5px' }}>
          <div className={`${styles['access-back-office-title']}`}>
            Backoffice Permissions
          </div>
          <div className={`${styles['access-back-office-description']}`}>
            Allow employees to sign in to your Backoffice using their email and
            access the following.
          </div>
        </div>
      </div>
    );
  }
}

export default AccessBackOffice;
